export default __webpack_public_path__ + "static/media/iconSaving.5f11287c.svg";